import type { IntegrationModuleChip } from "../types";

export function orderAndSplitChips(
  modules: IntegrationModuleChip[],
  maxVisible: number,
  label: (module: IntegrationModuleChip) => string,
  locale?: string
): { visible: IntegrationModuleChip[]; hidden: IntegrationModuleChip[] } {
  const ordered = [...modules].sort((a, b) => {
    if (a.isActive !== b.isActive) return a.isActive ? -1 : 1;
    return label(a).localeCompare(label(b), locale);
  });

  return {
    visible: ordered.slice(0, maxVisible),
    hidden: ordered.slice(maxVisible),
  };
}
